import { IOnInit } from "angular";
import { ProcessGroup, ProcessInformation } from "../../model/ProcessGroups";
import {
  ProcessInformationService,
  vsServiceName as ProcessInformationServiceName,
} from "../../services/processInformationService";
import { GridConfiguration } from "../../../records/views/recordGridView";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import { StateService } from "@uirouter/angularjs";

export class ProcessGridComponentController implements IOnInit {
  static $inject = [
    ProcessInformationServiceName,
    ColumnDefinitionServiceName,
    "$state",
  ];

  /*bindings*/
  gridConfiguration!: GridConfiguration;
  processGroups!: ProcessGroup[];
  /*end bindings*/

  columns: ColDef[] = [];

  constructor(
    readonly processInformationService: ProcessInformationService,
    private readonly columnDefinitionService: ColumnDefinitionService,
    private readonly $state: StateService
  ) {}

  $onInit() {
    this.columns = [
      this.columnDefinitionService.getLinkColDef({
        headerName: "info",
        iconClass: "fa fa-info-circle text-primary",
        colId: "detail",
        width: 20,
        stateExpression: `.group.detail({ groupId: data.GroupId, processInstancesId: data.Id})`,
      }),
      ...(this.gridConfiguration.columns ?? []),
      this.columnDefinitionService.getStringColDef({
        field: "Field1",
        header: "Field 1",
        cellRenderer: this.contextCellRendererFactory(1),
      }),
      this.columnDefinitionService.getStringColDef({
        field: "Field2",
        header: "Field 2",
        cellRenderer: this.contextCellRendererFactory(2),
      }),
      this.columnDefinitionService.getStringColDef({
        field: "Field3",
        header: "Field 3",
        cellRenderer: this.contextCellRendererFactory(3),
      }),
      this.columnDefinitionService.getStringColDef({
        field: "Field4",
        header: "Field 4",
        cellRenderer: this.contextCellRendererFactory(4),
      }),
      this.columnDefinitionService.getStringColDef({
        field: "Field5",
        header: "Field 5",
        cellRenderer: this.contextCellRendererFactory(5),
      }),
    ];
  }

  private contextCellRendererFactory(
    contextFieldNumber: number
  ): awk.grid.ICellRenderer {
    return (params) =>
      `<span title="${this.getContextFieldToolTip(
        params.data["GroupId"],
        contextFieldNumber
      )}">${params.value ?? ""}</span>`;
  }

  getContextFieldToolTip(groupId: string, field: number) {
    const group = this.processGroups.find((g) => g.Name === groupId);
    return group?.ContextFields.at(field - 1)?.DisplayName;
  }

  createProcess(processGroup: ProcessGroup, process: ProcessInformation) {
    return this.processInformationService
      .createNewProcessFlow(processGroup, process)
      .then((processResponse) =>
        this.$state.go(".group.detail", {
          groupId: processResponse.GroupId,
          processInstancesId: processResponse.Id,
        })
      );
  }
}
